import ClickAndCollectDayPickerWrapper from '@components/click-and-collect-day-picker-wrapper/ClickAndCollectDayPickerWrapper';

const CLICK_AND_COLLECT_DATES = {
  component: ClickAndCollectDayPickerWrapper,
  className: 'fieldLargeSmallMarginBottom',
  name: 'collectionDateTime',
  id: 'collectionDateTime',
  selectedDayMessageBody: "We'll keep your order for 7 days.",
  startWeekAtEarliestDate: true,
  required: true,
  validationMessageKeys: {
    required: 'Please select a day',
  },
};

export default CLICK_AND_COLLECT_DATES;
